<template>
  <div>
    <Loader :loading='loading' />
    <div class="home container-lg" v-if="!loading">
      <div class="h-channels-list mt-3 container-fluid" v-if='channels && channels.length > 0'>
        <div class="row h-top-title">
          <div class="col-6">
            <div class="d-md-table">
              <div class="d-md-table-cell">
                <h4 class="title-1">Top TV Channels</h4>
              </div>
            </div>
          </div>
          <!-- /.col -->
          <div class="col-6 text-right">
            <a :href="httpUrl + '#/live/home?__k=' + token" class="text-primary">
              View more »
            </a>
          </div>
        </div>
        <!-- /.h-top-title -->
        <div class="channel-lists-home">
          <carousel
            :nav='false'
            :responsive="{0:{items:3},400:{items:4},600:{items:5},750:{items:6},860:{items:7},1010:{items:8},1200:{items:10}}"
          >
            <ChannelGrid v-for="channel in channels" v-bind:key="channel.channel_id"
              :id="channel.channel_id"
              :thumbnail='channel.logo'
              :title="channel.name"
              :tooltip="channel.name"
              :category='channel.title'
              :favorite='channel.favourite_channel'
              :toHttp='true'
            />
          </carousel>
        </div>
      </div>
      <!-- /.h-channels-list -->
      <div class="h-shows-list mt-5 container-fluid">
        <div class="row h-top-title">
          <div class="col-6">
            <div class="d-md-table">
              <div class="d-md-table-cell">
                <h4 class="title-1">Latest TV Shows</h4>
              </div>
            </div>
          </div>
          <!-- /.col -->
          <div class="col-6 text-right">
            <router-link to="/tv-shows" class="text-primary">
              View more »
            </router-link>
          </div>
        </div>
        <!-- /.h-top-title -->
        <div class="row">
          <FilmGrid v-for="show in tvshows" v-bind:key="show.id"
            :id='show.id'
            type='tv-show'
            :url="'/tv-show/' + show.id" 
            :avatar='show.avatar'
            :played="show.is_played"
            :favorite="show.is_favorite"
            :secondaryTitle='show.secondary_title'
            :title="show.title"
            :year="null"
            :rate='show.rating'
            :watchlater='show.watch_later_count'
          />
        </div>
      </div>
      <!-- /.h-shows-list -->
      <div class="h-movies-list mt-5 container-fluid">
        <div class="row h-top-title">
          <div class="col-6">
            <div class="d-md-table">
              <div class="d-md-table-cell">
                <h4 class="title-1">Latest Movies</h4>
              </div>
            </div>
          </div>
          <!-- /.col -->
          <div class="col-6 text-right">
            <router-link to="/movies" class="text-primary">
              View more »
            </router-link>
          </div>
        </div>
        <!-- /.h-top-title -->
        <div class="row">
          <FilmGrid v-for="movie in movies" v-bind:key="movie.id"
            :id='movie.id'
            type='article'
            :url="'/movie/' + movie.id" 
            :avatar='movie.avatar'
            :played="movie.is_played"
            :favorite="movie.is_favorite !== null ? true : false"
            :secondaryTitle='movie.secondary_title'
            :title="movie.title"
            :year="movie.year"
            :rate='movie.rating'
            :watchlater='movie.watch_later_count'
          />
        </div>
      </div>
      <!-- /.h-movies-list -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import FilmGrid from "../components/FilmGrid";
import Loader from "../components/Loader";
import ChannelGrid from '../components/ChannelGrid';
import { authRequest, getAuthKey } from '../app/helpers';
import { httpUrl } from '../app/config';
import carousel from 'vue-owl-carousel';

export default {
  data() {
    return {
      loading: true,
      movies: [],
      tvshows: [],
      httpUrl,
      token: null,
      channels: [],
    } 
  },
  components: {
    FilmGrid,
    Loader,
    ChannelGrid,
    carousel,
  },
  name: "home",
  methods: {
    async fetchAll() {
      const req = await authRequest(this.$router, '/all');

      this.movies = req.articles;
      this.tvshows = req.tvShows;
      this.loading = false;
    },

    async fetchChannels() {
      const req = await authRequest(this.$router, '/channels?paginate=15');

      this.channels = req.data.slice(0, 18);
    },
  },
  mounted() {
    this.$store.commit("switchCategory", 1);
    this.$store.commit('bodyClass', 'home-page');

    this.token = getAuthKey();

    // this.$snack.success('You logged in successfully');
    this.fetchAll();
    this.fetchChannels();
  },
  watch: {
    $route (route, f) {
    }
  }
};
</script>


<style lang="scss">
</style>